import React, { Componentm, useEffect } from "react";
import { Loading } from "../Loading";
import "../Styles/AskModal.css";
import { SuccesCheck } from "./SuccesCheck";
import { ErrorCheck } from "./ErrorCheck";

export const ModalVerify = ({ show, valid, loading, closeModal, message, passPortal }) => {
  useEffect(() => {
    redirect();
  }, [valid]);

  const redirect = () => {
    if (valid) {
      setTimeout(() => {
        passPortal();
      }, 1000);
    }
  };
  return (
     <div
      className={`modal fade-in ${show ? "d-block" : ""}`} style={{
        background: "rgba(0,0,0,0.4)",
        zIndex: "99999"
      }}
      role="dialog"
    >
      <div className="modal-dialog modal-dialog-centered" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="exampleModalLongTitle">
              {loading ? "Verificando" : "Verificación"}
            </h5>
          </div>
          <div className="modal-body">
            {loading ? <Loading /> : valid ? <SuccesCheck/> : <ErrorCheck/>}
          </div>
          {!valid && !loading && (
            <div className="modal-footer border-top-0">
              <button
                type="button"
                className="btn btn-primary"
                data-dismiss="modal"
                onClick={() => closeModal()}
              >
                Cerrar
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
